/**
 * SettingsManager — Extracted from App class.
 * Handles unified settings (user + global) retrieval and updates.
 */
export class SettingsManager {
    constructor(deps) {
        this.deps = deps;
    }
    get cache() { return this.deps.dataCache; }
    async get() {
        this.deps.ensureAuthenticated();
        try {
            const cachedSettings = this.cache.getSettings();
            if (cachedSettings) {
                return cachedSettings;
            }
            const response = await this.deps.makeApiCallWithRetry(() => this.deps.getApi().getSettings());
            if (response.settings) {
                this.cache.updateData({
                    settings: response.settings,
                    timestamp: Date.now()
                });
            }
            return response.settings;
        }
        catch (error) {
            this.deps.handleError('getSettings', this.deps.toError(error));
            throw error;
        }
    }
    async update(settings) {
        this.deps.ensureAuthenticated();
        try {
            const response = await this.deps.makeApiCallWithRetry(() => this.deps.getApi().updateSettings({ settings }));
            if (response.settings) {
                this.cache.updateData({
                    settings: response.settings,
                    timestamp: Date.now()
                });
            }
            return response.settings;
        }
        catch (error) {
            this.deps.handleError('updateSettings', this.deps.toError(error));
            throw error;
        }
    }
}
